/* eslint-disable @typescript-eslint/naming-convention */
export const BOOKINGS = {
  PSI: {
    OPEN: '15,17,18,20,22,23,25,30,40,50',
    COMPLETED: '60',
  },
  LT: {
    OPEN: '10,20,21,22,23,24,25',
    OPEN_INQUIRY: '10,20,21,22,23,24,25',
    COMPLETED: '26,28',
    COPY_FROM_PREVIOUS_ORDER: '10,20,21,22,23,24,25,26,28',
    DRAFTS: '1,2,3,4',
  },
  AUDIT: {
    OPEN: '15,17,18,20,22,23,25,30,40,41,42,50,51',
    COMPLETED: '55,60',
  },
  SASO: {
    OPEN: '10,15,17,20,21,22,23,25,30,40,50,56',
    COMPLETED: '60',
  },
  CERTIFICATION: {
    OPEN: '10,15,17,20,21,22,23,25,30,40,50,56',
    COMPLETED: '60',
  },
  TRAINING: {
    OPEN: '18,20,21,40',
    COMPLETED: '60',
  },
  WQS: {
    OPEN: '110,120,123,127,130,135,140,150,160,170,180,185,190,200,205,210',
    OPEN_EXPORT: '15,17,18,20,22,23,25,30,40,50',
    COMPLETED: '220',
    COMPLETED_EXPORT: '60',
  },
};
